import { lazy } from "react";
import { RouteObject } from "../../helpers/tixxt-router";

const ContactsPage = lazy(() => import("./ContactsPage"));
const ContactNewPage = lazy(() => import("./ContactNewPage"));
const ContactDetailPage = lazy(() => import("./ContactDetailPage"));
const ContactEditPage = lazy(() => import("./ContactEditPage"));

const contactsRoutes: RouteObject[] = [
  { path: "/contacts", element: <ContactsPage /> },
  { path: "/contacts/new", element: <ContactNewPage /> },
  { path: "/contacts/:contactId", element: <ContactDetailPage /> },
  { path: "/contacts/:contactId/edit", element: <ContactEditPage /> },
];

export default contactsRoutes;
